import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import './BlogDetailsStyled.css';

const ProductApplicationForm = () => {
  const location = useLocation();
  const { id } = location.state || {}; // get product/blog id from previous page
  const [product, setProduct] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    companyName: '',
    companyLocation: '',
    description: '',
    productTitle: '',
  });

  // Fetch product details
  useEffect(() => {
    if (id) {
      axios.get(`/api/blogs/${id}`)
        .then(res => {
          setProduct(res.data);
          setFormData(prev => ({
            ...prev,
            productTitle: res.data.title, // automatically fill product title
          }));
        })
        .catch(err => console.error(err));
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Example handleSubmit
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post(
      "/api/product-applications",
      formData
    );
    console.log("Form submitted successfully:", res.data);

    // Reset the form after successful submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      companyName: '',
      companyLocation: '',
      description: '',
      productTitle: product.title, // keep product title
    });

    alert("Application submitted successfully!");
  } catch (err) {
    console.error("Error submitting form:", err);

    // Check if the backend sent a 400 error with a custom message
    if (err.response && err.response.status === 400) {
      alert(err.response.data.message); // e.g., "Email already registered"
    } else {
      alert("Failed to submit application. Please try again.");
    }
  }
};




  if (!product) return <p>Loading product details...</p>;

  return (
    <div className="application-form-wrapper">
      <h1>Contact Us {product.title}</h1>
      <form onSubmit={handleSubmit} className="application-form">
        <label>Product Title</label>
        <input 
          type="text" 
          name="productTitle" 
          value={formData.productTitle} 
          readOnly 
        />

        <label>Name</label>
        <input 
          type="text" 
          name="name" 
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label>Email</label>
        <input 
          type="email" 
          name="email" 
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Phone</label>
        <input 
          type="tel" 
          name="phone" 
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <label>Company Name</label>
        <input 
          type="text" 
          name="companyName" 
          value={formData.companyName}
          onChange={handleChange}
        />

        <label>Company Location</label>
        <input 
          type="text" 
          name="companyLocation" 
          value={formData.companyLocation}
          onChange={handleChange}
        />

        <label>Description / Message</label>
        <textarea 
          name="description" 
          value={formData.description}
          onChange={handleChange}
          placeholder="Any specific requirements or message"
        />

        <button type="submit" className="submit-button">Submit Application</button>
      </form>
    </div>
  );
};

export default ProductApplicationForm;


